import { Toast } from 'primereact/toast'
import { createContext, type FC, type ReactNode, type RefObject, useContext, useRef } from 'react'

const ToastContext = createContext<RefObject<Toast | null> | null>(null)
const useToast = () => useContext(ToastContext)

export const ToastProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const toast = useRef<Toast>(null)
  return (
    <ToastContext.Provider value={toast}>
      <div className='w-full h-full'>
        <Toast ref={toast} className='' />
        {children}
      </div>
    </ToastContext.Provider>
  )
}

export default useToast
